/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import { call, put, takeEvery, select } from "redux-saga/effects";
import { getRequest, postRequest, putRequest } from "../../helpers/Api";
import { types } from "../reducers/contractors";
import { userNotAuthorizedHandler } from "./authentication";

function* addContractor({ payload }) {
  yield put({ type: types.SET_CONTRACTOR_LOADING, payload: { loading: true } });
  try {
    const res = yield call(payload.id ? putRequest : postRequest, {
      url: payload.id ? `/contractors/${payload.id}` : "/contractors",
      jsonContentType: true,
      authorized: true,
      body: JSON.stringify(payload.contractor),
    });

    if (res.status === 409) {
      const errorMessage =
        res.response && res.response.message
          ? res.response.message
          : res.message === "Conflict"
          ? "Contractor already exists"
          : res.message;
      payload.onFailure(errorMessage, {
        errors: [
          {
            key: res.response && res.response.field ? res.response.field : "number",
            error: errorMessage,
          },
        ],
      });
    } else if (res.status === 401) {
      yield call(userNotAuthorizedHandler);
      payload.onSuccess(null);
      return;
    } else if (res.status === 200) {
      payload.onSuccess(res);
      yield put({
        type: types.FETCH_CONTRACTOR_REQUEST,
        payload: { page: 1, perPage: 20, onFailure: payload.onFailure },
      });
    } else {
      payload.onFailure(res.message);
    }
  } catch (err) {
    // @ts-ignore
    payload.onFailure(err.message || "Internal server error");
  }

  yield put({ type: types.SET_CONTRACTOR_LOADING, payload: { loading: false } });
}
/**
 * Fetch contractors when filters are changed
 */
function* fetchContractorRequest({ payload }) {
  yield put({ type: types.SET_CONTRACTOR_LOADING, payload: { loading: true } });
  const {
    page: prevPage,
    perPage: prevPerPage,
    qs: prevQs,
  } = yield select((state) => state.contractors);
  const params = new URLSearchParams();
  params.append("perPage", prevPerPage || "20");
  params.append("page", prevPage || "0");
  params.append("qs", prevQs || "");

  const response = yield call(getRequest, {
    url: `/contractors?${params.toString()}`,
    authorized: true,
  });

  if (response.status === 401) {
    yield call(userNotAuthorizedHandler);
    return;
  }

  if (response.status === 200) {
    yield put({ type: types.ADD_CONTRACTORS, payload: { contractors: response.result } });
    yield put({
      type: types.SET_CONTRACTOR_TOTAL_ITEMS,
      payload: {
        totalItems: response.totalItems,
      },
    });
  } else {
    payload.onFailure(response.message || "Internal server error");
  }
  yield put({ type: types.SET_CONTRACTOR_LOADING, payload: { loading: false } });
}
/**
 * Fetch contractors when filters are changed
 */
function* fetchContractorTypeCodesRequest({ payload }) {
  yield put({ type: types.SET_CONTRACTOR_LOADING, payload: { loading: true } });
  const response = yield call(getRequest, {
    url: `/contractors/type-codes`,
    authorized: true,
  });

  if (response.status === 401) {
    yield call(userNotAuthorizedHandler);
    return;
  }

  if (response.status === 200) {
    yield put({ type: types.ADD_CONTRACTOR_TYPE_CODES, payload: { typeCodes: response.result } });
  } else {
    payload.onFailure(response.message || "Internal server error");
  }
  yield put({ type: types.SET_CONTRACTOR_LOADING, payload: { loading: false } });
}
/**
 * Fetch contractors when filters are changed
 */
function* fetchLocationRequest({ payload }) {
  yield put({ type: types.SET_CONTRACTOR_LOADING, payload: { loading: true } });
  const response = yield call(getRequest, {
    url: `/locations`,
    authorized: true,
  });

  if (response.status === 401) {
    yield call(userNotAuthorizedHandler);
    return;
  }

  if (response.status === 200) {
    yield put({ type: types.ADD_CONTRACTOR_LOCATIONS, payload: { locations: response.result } });
  } else {
    payload.onFailure(response.message || "Internal server error");
  }
  yield put({ type: types.SET_CONTRACTOR_LOADING, payload: { loading: false } });
}
/**
 * Fetch contractors when filters are changed
 */
function* fetchCompaniesLocationRequest({ payload }) {
  yield put({ type: types.SET_CONTRACTOR_LOADING, payload: { loading: true } });
  const response = yield call(getRequest, {
    url: `/company/sub-companies`,
    authorized: true,
  });

  if (response.status === 401) {
    yield call(userNotAuthorizedHandler);
    return;
  }

  if (response.status === 200) {
    yield put({ type: types.ADD_CONTRACTOR_COMPANIES, payload: { companies: response.result } });
  } else {
    payload.onFailure(response.message || "Internal server error");
  }
  yield put({ type: types.SET_CONTRACTOR_LOADING, payload: { loading: false } });
}

/**
 * Fetch contractors when filters are changed
 */
function* fetchContractorJobsRequest({ payload }) {
  yield put({ type: types.SET_CONTRACTOR_LOADING, payload: { loading: true } });
  const response = yield call(getRequest, {
    url: `/jobs`,
    authorized: true,
  });

  if (response.status === 401) {
    yield call(userNotAuthorizedHandler);
    return;
  }

  if (response.status === 200) {
    yield put({ type: types.ADD_CONTRACTOR_JOBS, payload: { jobs: response.result } });
  } else {
    payload.onFailure(response.message || "Internal server error");
  }
  yield put({ type: types.SET_CONTRACTOR_LOADING, payload: { loading: false } });
}

export default function* sagas() {
  yield takeEvery(types.ADD_CONTRACTOR, addContractor);
  yield takeEvery(types.UPDATE_CONTRACTOR, addContractor);
  yield takeEvery(types.FETCH_CONTRACTOR_REQUEST, fetchContractorRequest);
  yield takeEvery(types.FETCH_CONTRACTOR_LOCATION_REQUEST, fetchLocationRequest);
  yield takeEvery(types.FETCH_COMPANIES_LOCATION_REQUEST, fetchCompaniesLocationRequest);
  yield takeEvery(types.FETCH_CONTRACTOR_JOBS_REQUEST, fetchContractorJobsRequest);
  yield takeEvery(types.FETCH_CONTRACTOR_TYPE_CODES_REQUEST, fetchContractorTypeCodesRequest);
}
